import { useState,useEffect } from "react";
import { Container, Row,Col } from "react-bootstrap";
import {ArrowRightCircle} from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.svg";
import bgImage from "../assets/img/girlwaving.gif";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
export const Banner = () => {
    const [loopNum,setLoopNum] = useState(0);
    const [isDeleting,setIsDeleting] = useState(false);
    const toRotate = ["ML Enthusiast !","Web Developer.","Technical Writer :)"];
    const [text,setText] = useState('');
    const [delta,setDelta] = useState(300-Math.random()*100);
    const period = 2000;
    useEffect(()=>{
        let ticker = setInterval(()=>{
           tick();
        },delta)
        return ()=>{ clearInterval(ticker)};
    },[text])
    const tick =()=>{
        let i  = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0,text.length-1):fullText.substring(0,text.length+1);


        setText(updatedText);

        if (isDeleting){
            setDelta(prevDelta=>prevDelta/2)
        }
        if(!isDeleting && updatedText===fullText){
            setIsDeleting(true);
            setDelta(period);
        }else if(isDeleting && updatedText===''){
            setIsDeleting(false);
            setLoopNum(loopNum+1);
            setDelta(500);

        }
    }
  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
          <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Welcome to my Portfolio</span>
                <h1>{`Hi! I'm Priyal`} <h1><span className="txt-rotate" dataPeriod="1000" data-rotate='[ "ML Enthusiast!", "Web Developer.", "Technical Writer :)" ]'><span className="wrap">{text}</span></span></h1></h1>
                <p>
              👋 Hey! I'm a tech enthusiast with an insatiable curiosity!
              🧠 I dive into AI's possibilities, turning data into insights. 
                 
              📝 I simplify the complex, sharing tech passions. 
              📚 Learning from others' experiences enriches my journey. 
              🚀  From web apps to ML projects, innovation drives me.
              By day, I code and create, crafting digital wonders. By night, I'm a quantum explorer, delving into the mystic quantum computing.  
              Welcome to my digital realm—a fusion of creativity, tech, and exploration!
            </p>
                  {/* <button onClick={() => console.log('connect')}>Let’s Connect <ArrowRightCircle size={25} /></button> */}
              </div>}
             

            </TrackVisibility>
            {/* <span className="">wlecome to my portfolio</span>
            <h1>
              {"Hi I am a Developer"}
              <span className="wrap">{text}</span>
            </h1>
            <p>
              👋 Hey! I'm a tech enthusiast wearing many hats: 
              🧠ML Enthusiast: I dive into AI's possibilities, turning data into insights. 
              💻 Web Dev: Crafting digital experiences that captivate and engage. 
              📝 Tech Writer: I simplify the complex, sharing tech passions. 
              📚 Book Lover: Learning from others' experiences enriches my journey. 
              🚀 Portfolio: From web apps to ML projects, innovation drives me. 
              Welcome to my digital realm—a fusion of creativity, tech, and exploration!
            </p>
            <button onClick={() => console.log('connect')}>Let's Connect<ArrowRightCircle size={25}></ArrowRightCircle></button> */}
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={bgImage} alt="Header Img" />
          </Col>
          {/* <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={bgImage} alt="Header Img"/>
                </div>}
            </TrackVisibility> */}
        </Row>
      </Container>
    </section>
  );
};
